export const date = {
    labels: {
        second: "Segundo",
        seconds: "Segundos",
        minute: "Minuto",
        minutes: "Minutos",
        hour: "Hora",
        hours: "Horas",
        day: "Dia",
        days: "Dias",
        week: "Semana",
        month: "Month",
        months: "Months",
    },
};